import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { FirmScopeJourney } from "@/features/firms/components/firm-scope-journey"
import { firmRecordQueries } from "@/queries/firm-record"
import { firmQueries } from "@/queries/firms"
import { permissionQueries } from "@/queries/permissions"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/scope/"
)({
  staticData: { attention: "firm.permissions" },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(firmQueries.detail(params.firmId)),
      context.queryClient.ensureQueryData(firmRecordQueries.permissions()),
      context.queryClient.ensureQueryData(
        firmRecordQueries.scope(params.firmId)
      ),
      context.queryClient.ensureQueryData(permissionQueries.groups()),
    ]),
  component: FirmScopePage,
})

function FirmScopePage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <FirmScopeJourney
      firm={firm}
      onFinished={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/authorisation",
          params: { firmId },
        })
      }
    />
  )
}
